import { defineMessages } from 'react-intl';

export default defineMessages({
    PropertyIncidentsQuestion: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.question',
        defaultMessage: "Were there any third party damages?"
    },
    PropertyIncidentsQuestionWT: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.question wt',
        defaultMessage: "Were there any third party damages?"
    },
    PropertyIncidentsQuestionRT: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.question rt',
        defaultMessage: "Were there any third party damages?"
    },
    Yes: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.Yes',
        defaultMessage: "Yes"
    },
    No: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.No',
        defaultMessage: "No"
    },
    PropertySection: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.PropertySection',
        defaultMessage: "Property Section"
    },
    Number: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.No.',
        defaultMessage: "No."
    },
    PropertyLocation: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.PropertyLocation',
        defaultMessage: "Property Location"
    },
    Edit: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.Edit',
        defaultMessage: "Edit"
    },
    Delete: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.Delete',
        defaultMessage: "Delete"
    },
    AddProperty: {
        id: 'wni.fnol.pa.views.incidentdetails.propertyIncidents.AddProperty',
        defaultMessage: "Add Property"
    }
})